import { Observable } from 'rxjs'
import { StateObservable } from 'redux-observable'
import { ignoreElements, tap, map } from 'rxjs/operators'
import { GlobalState } from 'store'
import { EntityType, Platform } from 'api'
import { ofEntityUpdateType } from './epicUtils'
import { BTQAction } from 'epics'

export function platformVersionEpic(
  action$: Observable<BTQAction>,
  _state$: StateObservable<GlobalState>,
  _dependencies: {}
): Observable<BTQAction> {
  return action$.pipe(
    ofEntityUpdateType(EntityType.PLATFORM, true),
    map(update => update.entity),
    tap((platform: Platform) => console.log(`Connected to platform build ${platform.version}`)),
    ignoreElements()
  )
}
